/* Datei: src/pages/BlogAdmin/BlogEditor.js */
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';
import { useParams, useNavigate } from 'react-router-dom';
import config from "../../config/config";
import AdminPageFrame from '../../components/admin/AdminPageFrame';
import './BlogAdmin.css';

const BlogEditor = () => {
  const { articleId } = useParams(); // "new" oder eine existierende ID
  const navigate = useNavigate();
  const [originalContent, setOriginalContent] = useState('');
  const [editorContent, setEditorContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchAndTransform = async () => {
      if (articleId === "new") {
        setOriginalContent("<p>Neuer Artikel</p>");
        setEditorContent("<p>Neuer Artikel</p>");
        setLoading(false);
      } else {
        try {
          console.log("[BlogEditor] Lade vollständigen Originalartikel für Artikel-ID:", articleId);
          // Ruft den neuen Endpunkt auf, der den vollen Artikelinhalt extrahiert
          const fullRes = await axios.get(`${config.API_BASE_URL}/api/fetch-full-article/${articleId}`);
          if (!fullRes.data || !fullRes.data.fullText) {
            throw new Error("Kein vollständiger Artikelinhalt gefunden.");
          }
          setOriginalContent(fullRes.data.fullText);
          console.log("[BlogEditor] Vollständiger Originalartikel geladen.");
          console.log("[BlogEditor] Sende Inhalt zur Transformation...");
          const transformRes = await axios.post(`${config.API_BASE_URL}/api/transform-article`, { content: fullRes.data.fullText });
          if (!transformRes.data || !transformRes.data.transformedContent) {
            throw new Error("Transformation hat keinen Inhalt zurückgeliefert.");
          }
          setEditorContent(transformRes.data.transformedContent);
          console.log("[BlogEditor] Transformierter Inhalt erhalten.");
        } catch (error) {
          console.error("[BlogEditor] Fehler beim Laden/Transformieren des Artikels:", error);
          setMessage("Fehler beim Laden oder Transformieren des Artikels.");
        } finally {
          setLoading(false);
        }
      }
    };
    fetchAndTransform();
  }, [articleId]);

  const handleSave = async () => {
    try {
      console.log("[BlogEditor] Speichere bearbeiteten Artikel für Artikel-ID:", articleId);
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}`, { content: editorContent });
      setMessage("Artikel erfolgreich gespeichert!");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Speichern des Artikels:", error);
      setMessage("Fehler beim Speichern des Artikels.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Soll dieser Artikel wirklich gelöscht werden?")) {
      try {
        await axios.delete(`${config.API_BASE_URL}/api/blog-articles/${articleId}`);
        setMessage("Artikel gelöscht!");
        navigate("/dashboard/blog");
      } catch (error) {
        console.error("[BlogEditor] Fehler beim Löschen:", error);
        setMessage("Fehler beim Löschen des Artikels.");
      }
    }
  };

  const handlePublish = async () => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}/publish`);
      setMessage("Artikel publiziert!");
      navigate("/dashboard/blog");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Publizieren:", error);
      setMessage("Fehler beim Publizieren des Artikels.");
    }
  };

  const handleIgnore = async () => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}/ignore`);
      setMessage("Artikel ignoriert!");
      navigate("/dashboard/blog");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Ignorieren:", error);
      setMessage("Fehler beim Ignorieren des Artikels.");
    }
  };

  if (loading) {
    return (
      <AdminPageFrame
        title="Blog Editor"
        subtitle="Originalquelle und bearbeitete Fassung werden geladen."
        badge="Content Operations"
      >
        <div>Lade Editor...</div>
      </AdminPageFrame>
    );
  }

  return (
    <AdminPageFrame
      title="Blog Editor"
      subtitle="Originalquelle und bearbeitete Fassung nebeneinander fuer echte Redaktionsarbeit."
      badge="Content Operations"
    >
      <div className="blog-editor-surface">
        <div className="blog-editor-grid">
          <section className="blog-editor-pane">
            <div>
              <h2>Originalartikel</h2>
              <p className="blog-admin-meta">Neuer Artikel</p>
            </div>
            <div className="blog-editor-pane__content" dangerouslySetInnerHTML={{ __html: originalContent }} />
          </section>
          <section className="blog-editor-pane">
            <div>
              <h2>Bearbeiteter Artikel</h2>
              <p className="blog-admin-meta">Normal, B, U, Listen und Links bleiben im Editor direkt nutzbar.</p>
            </div>
            <ReactQuill
              value={editorContent}
              onChange={setEditorContent}
            />
          </section>
        </div>
        <div className="blog-editor-actions">
          <button onClick={handleSave} className="blog-admin-button blog-admin-button--primary">
            Speichern
          </button>
          <button onClick={handleDelete} className="blog-admin-button blog-admin-button--danger">
            Loeschen
          </button>
          <button onClick={handleIgnore} className="blog-admin-button blog-admin-button--warning">
            Ignorieren
          </button>
          <button onClick={handlePublish} className="blog-admin-button blog-admin-button--success">
            Publizieren
          </button>
        </div>
        {message ? <div className="blog-editor-message">{message}</div> : null}
      </div>
    </AdminPageFrame>
  );
};

export default BlogEditor;
